import {
  getComparableOfferPrice,
  getOfferLink,
  getRetailerNameFromOffer,
} from './simpleProductPageShared';
import {
  AFFILIATE_PAGE_SOURCE,
  trackPricedAffiliateDealClick,
} from '../../utils/enhancedAnalytics';

export function trackDbPdpOfferClick(offer, { productSlug, isPrefetchedDbOffers, priceOptions, search, freshnessState } = {}) {
  try {
    if (!isPrefetchedDbOffers || !productSlug) return;
    const href = getOfferLink(offer);
    const salePrice = getComparableOfferPrice(offer, priceOptions);
    if (!href || salePrice == null) return;
    const retailer = getRetailerNameFromOffer(offer);
    const payload = {
      retailer,
      affiliateUrl: href,
      salePrice,
      pageSource: AFFILIATE_PAGE_SOURCE.PRODUCT_PDP,
      productSlug,
      offerId: offer?.id || offer?.offer_id,
      search,
      placement: 'pdp_offers',
    };
    if (freshnessState) payload.freshnessState = freshnessState;
    trackPricedAffiliateDealClick(payload);
  } catch {
    // Analytics must never block outbound navigation.
  }
}
